import type { IMsalContext } from '@azure/msal-react';
import { types } from 'mobx-state-tree';

// eslint-disable-next-line import/prefer-default-export -- MST models are not default exports
export const CoreModel = types
  .model('Core')
  .props({
    msalDetails: types.maybeNull(types.frozen<IMsalContext>()),
    isAuthenticated: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    setMsalDetails: (details: IMsalContext | null) => {
      self.msalDetails = details;
    },
    setIsAuthenticated: (isAuthenticated: boolean) => {
      self.isAuthenticated = isAuthenticated;
    },
  }));
